import qs from 'qs'
import AuthService from '@/packages/auth-service'
import store from '@/app/store'
import CONFIG from '@/app/config/config'
import { getMockedResponse } from '@/shared/lib/getMockedResponse'
import { getPaginatePaymentLinkHistoryMock } from '@/shared/mocks/payment-links'
import b2bApiClient from '@/shared/api/b2b-client'

export class PaymentLinkApiService {
  constructor() {
    this.client = b2bApiClient.getClient()
    this.isMock = CONFIG.USE_MOCKS === 'true'
  }

  get _accessToken() {
    return store.state.auth.access_token || AuthService.getAccessToken()
  }

  get _headers() {
    return {
      'Content-Type': 'application/json',
      'x-access-token': this._accessToken,
    }
  }

  async getPaginatePaymentLinkHistory(params) {
    if (this.isMock) {
      return getMockedResponse(getPaginatePaymentLinkHistoryMock)
    }

    const filteredParams = Object.fromEntries(
      // eslint-disable-next-line no-unused-vars
      Object.entries(params).filter(([_, value]) => {
        if (value === null || value === undefined) {
          return false
        }
        if (Array.isArray(value)) {
          return value.length > 0
        }
        if (typeof value === 'boolean') {
          return value === true
        }
        return String(value).trim() !== ''
      })
    )

    return await this.client.client.get(`/processing/partner/transactions`, {
      params: filteredParams,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
      headers: this._headers,
    })
  }

  async getTransactionDetailsByHash(hash) {
    return await this.client.client.get(
      `/processing/partner/transactions/${hash}`,
      {
        headers: this._headers,
      }
    )
  }

  async getExcelReport(params) {
    return await this.client.client.get(
      '/processing/partner/invoices/excel-report',
      {
        params,
        paramsSerializer: (params) => {
          const searchParams = new URLSearchParams()
          Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              if (value.length > 0) {
                value.forEach((item) => {
                  searchParams.append(key, item)
                })
              }
            } else {
              searchParams.append(key, value)
            }
          })
          return searchParams.toString()
        },
        headers: this._headers,
        responseType: 'blob',
      }
    )
  }
}

export const paymentLinkApiService = new PaymentLinkApiService()
export default paymentLinkApiService
